import MuiModal from "@mui/material/Modal";
import Bounce from "react-reveal/Bounce";

export interface IModal {
  open: boolean;
  onClose: any;
  children: any;
}

export default function Modal(props: IModal) {
  //TODO: Remove dependency on MUI
  return (
    <MuiModal open={props.open} onClose={props.onClose}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <Bounce top duration={500}>
          {props.children}
        </Bounce>
      </div>
    </MuiModal>
  );
}
